import {
    LIST_DEPENDENCIES,
    LIST_DEPENDENCIES_SUCCESS,
    LIST_DEPENDENCIES_ERROR,
    ADD_DEPENDENCIES,
    SAVE_DEPENDENCIES,
    SAVE_DEPENDENCIES_SUCCESS,
    SAVE_DEPENDENCIES_ERROR,
    DELETE_DEPENDENCIES,
    DELETE_DEPENDENCIES_SUCCESS,
    DELETE_DEPENDENCIES_ERROR,
    EDIT_DEPENDENCIES,
    UPDATE_DEPENDENCIES,
    UPDATE_DEPENDENCIES_SUCCESS,
    UPDATE_DEPENDENCIES_ERROR
} from '../types';

import clienteAxios from '../config/axios';
import authToken from '../config/token';

import dependenciesData from '../data/dependencies';
import { ErrorMessage, SuccessMessage, WaitingMessage } from '../components/extras/toastMessages';
import { MSG_CREATE_SUCCESS, MSG_UPDATE_SUCCESS, MSG_DELETING, MSG_DELETE_SUCCESS } from '../constants/messages';
import Swal from 'sweetalert2';
import { METHOD_DISABLED } from '../constants/requestMethods';

const controller = 'dependencia';

//LISTAR DEPENDENCYS
export function listDependenciesAction(params) {
    return async (dispatch) => {
        //Inicializo
        dispatch( listDependencies() );
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.get(`/${controller}`, { params });
            //Obtengo los datos
            const dependencies = response.data;
            //const dependencies = dependenciesData;
            //Llamo al dispatch
            dispatch( listDependenciesSuccess(dependencies.content) );
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( listDependenciesError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const listDependencies = () => ({
    type: LIST_DEPENDENCIES,
    payload: true
});

const listDependenciesSuccess = dependencies => ({
    type: LIST_DEPENDENCIES_SUCCESS,
    payload: dependencies
});

const listDependenciesError = error => ({
    type: LIST_DEPENDENCIES_ERROR,
    payload: error
});

//ADD DEPENDENCY
export function addDependenciesAction(showForm) {
    return (dispatch) => {
        //Inicializo
        dispatch( addDependencies(false) );
        //Abro el formulario
        showForm();
    }
}

const addDependencies = isEdit => ({
    type: ADD_DEPENDENCIES,
    payload: isEdit
});

//SAVE DEPENDENCY
export function saveDependenciesAction(dependency, handleClose) {
    return async (dispatch) => {
        //Inicializo
        dispatch( saveDependencies() );
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.post(`/${controller}`, dependency);
            //Obtengo los datos
            //const res = response.data;
            //Llamo al dispatch
            dispatch( saveDependenciesSuccess(response.data) );
            //Cierro la ventana
            handleClose();
            //Mensaje
            SuccessMessage(MSG_CREATE_SUCCESS);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( saveDependenciesError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const saveDependencies = () => ({
    type: SAVE_DEPENDENCIES,
    payload: true
});


const saveDependenciesSuccess = dependency => ({
    type: SAVE_DEPENDENCIES_SUCCESS,
    payload: dependency
});

const saveDependenciesError = error => ({
    type: SAVE_DEPENDENCIES_ERROR,
    payload: error
});

//EDIT DEPENDENCY
export function editDependenciesAction(dependency, showForm) {
    return async (dispatch) => {
        //Inicializo
        dispatch( editDependencies(dependency) );
        //Abro el formulario
        showForm();
    }
}

const editDependencies = dependency => ({
    type: EDIT_DEPENDENCIES,
    payload: dependency
});

//UPDATE DEPENDENCY
export function updateDependenciesAction(dependency, handleClose) {
    return async (dispatch) => {
        //Inicializo
        dispatch( updateDependencies() );
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.put(`/${controller}/${dependency.id}`, dependency);
            //Obtengo los datos
            //const res = response.data;
            //Llamo al dispatch
            dispatch( updateDependenciesSuccess(response.data) );
            //Cierro la ventana
            handleClose();
            //Mensaje
            SuccessMessage(MSG_UPDATE_SUCCESS);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( updateDependenciesError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const updateDependencies = () => ({
    type: UPDATE_DEPENDENCIES,
    payload: true
});

const updateDependenciesSuccess = dependency => ({
    type: UPDATE_DEPENDENCIES_SUCCESS,
    payload: dependency
});

const updateDependenciesError = error => ({
    type: UPDATE_DEPENDENCIES_ERROR,
    payload: error
});

//DELETE DEPENDENCY
export function deleteDependenciesAction(dependency) {
    return async (dispatch) => {
        //Inicializo
        dispatch( deleteDependencies() );
        //Mensaje de Espera
        WaitingMessage(MSG_DELETING);
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            // const response = await clienteAxios.delete(`/${controller}/${dependency.id}`);
            const response = await clienteAxios.put(`/${controller}/${dependency.id}/${METHOD_DISABLED}`);
            //Obtengo los datos
            //const res = response.data;
            //Llamo al dispatch
            dispatch( deleteDependenciesSuccess(response.data) );
            //Oculto espera
            Swal.close();
            //Mensaje
            SuccessMessage(MSG_DELETE_SUCCESS);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( deleteDependenciesError(data) );
            //Oculto espera
            Swal.close();
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const deleteDependencies = () => ({
    type: DELETE_DEPENDENCIES,
    payload: true
});

const deleteDependenciesSuccess = dependency => ({
    type: DELETE_DEPENDENCIES_SUCCESS,
    payload: dependency
});

const deleteDependenciesError = error => ({
    type: DELETE_DEPENDENCIES_ERROR,
    payload: error
});